const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function randomAlias(length = 6): string {
  const a = new Uint8Array(length);
  crypto.getRandomValues(a);
  let out = '';
  for (let i = 0; i < length; i++) out += ALPHABET[a[i]! % ALPHABET.length];
  return out;
}
